import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ChartsV4 from '../../services/charts';

export default function AmColumnAndLineChart(props) {
  const { chartId, containerClass, stats, options, type } = props;
  const chart = useRef(null);

  useEffect(() => {
    if (type === 'twoColumnAndLine') {
      ChartsV4.ready(() => {
        chart.current = ChartsV4.twoColumnAndLine(stats, chartId, options);
      });
    } else if (type === 'layeredColumns') {
      ChartsV4.ready(() => {
        chart.current = ChartsV4.layeredColumns(stats, chartId, options);
      });
    } else if (type === 'multiLine') {
      ChartsV4.ready(() => {
        chart.current = ChartsV4.multiLine(stats, chartId, options);
      });
    } else {
      ChartsV4.ready(() => {
        chart.current = ChartsV4.columnAndLine(stats, chartId, options);
      });
    }

    return () => {
      if (chart.current) {
        chart.current.dispose();
      }
    };
  });

  return <div className={containerClass} id={chartId} />;
}

AmColumnAndLineChart.propTypes = {
  containerClass: PropTypes.string,
  chartId: PropTypes.string.isRequired,
  stats: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  options: PropTypes.shape({
    category: PropTypes.string.isRequired,
    yLabel: PropTypes.string.isRequired,
    columnValueKey: PropTypes.string,
    lineValueKey: PropTypes.string,
    lineAreaValueKey: PropTypes.string,
    columnSeriesName: PropTypes.string,
    lineSeriesName: PropTypes.string,
    lineAreaSeriesName: PropTypes.string,
    valueAxisLimits: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number,
    }),
    isRotated: PropTypes.bool,
    isStacked: PropTypes.bool,
    wrapXLabels: PropTypes.shape({
      truncate: PropTypes.bool,
      wrap: PropTypes.bool,
      maxWidth: PropTypes.number,
    }),
    showLegend: PropTypes.bool,
  }).isRequired,
  type: PropTypes.string,
};

AmColumnAndLineChart.defaultProps = {
  containerClass: '',
  type: 'columnAndLine',
};
